<template>
  <section class="wrapper" id="section-4">
    <div class="flex flex-col gap-3 sm:gap-4 p-3 lg:p-6">
      <div class="flex flex-col lg:flex-row items-stretch gap-2">
        <BannerItem
            v-for="item in bannerItems"
            :key="item.number"
            :class="item.arrowClass"
            :item="item"
        />
      </div>
      <div class="card-hover">
        <span>Download presentation whitepaper</span>
      </div>
    </div>
  </section>
</template>

<script setup>
import BannerItem from './section4/BannerItem'

const bannerItems = [
  {
    number: '01',
    icon: '/stima/assets/images/icons/banner-4/01.svg',
    title: 'Profiling',
    text: 'Create your asset profile in just a few steps — verified for authenticity and accuracy.',
    arrowClass: 'lg:basis-1/5 banner-4-arrow'
  },
  {
    number: '02',
    icon: '/stima/assets/images/icons/banner-4/02.svg',
    title: 'Real-Time Valuation',
    text: 'Get instant, AI-powered valuation updated in real time.',
    arrowClass: 'lg:basis-1/5 banner-4-arrow'
  },
  {
    number: '03',
    icon: '/stima/assets/images/icons/banner-4/03.svg',
    title: 'Certification',
    text: 'Secure compliance checks with AML, KYC and KYO.',
    arrowClass: 'lg:basis-1/5 banner-4-arrow'
  },
  {
    number: '04',
    icon: '/stima/assets/images/icons/banner-4/04.svg',
    title: 'Custody',
    text: 'Store assets safely in STIMA’s certified vaults — with access to a secure trading space.',
    arrowClass: 'lg:basis-1/5 banner-4-arrow'
  },
  {
    number: '05',
    icon: '/stima/assets/images/icons/banner-4/05.svg',
    title: 'Tokenization',
    text: 'Turn assets into STIMA Tokens — trade, sell, or redeem for other assets.',
    successIcon: '/stima/assets/images/icons/success-with-bg.svg',
    arrowClass: 'lg:basis-1/5'
  }
]
</script>
